<template>
	<Layout header-class="header-left-align" nav-alignment="left" :topbar-style="2">
		<!-- Start Slider area -->
		<div class="slider-area slider-style-2 variation-2 height-450 bg_image"
				 :style="{'background-image': `url(${require(`@/assets/images/bwt/ai-banner.jpg`)})`}">
			<div class="container">
				<div class="row">
					<div class="col-lg-8 col-xl-6">
						<div class="inner text-start" data-aos="fade-up" data-aos-delay="100">
							<h2 class="w-600 title text-left">帮助企业定制AI战略，培养AI人才，加速AI落地</h2>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="rwt-advance-tab-area rn-section-gap">
			<div class="container">
				<h2 class="w-600 title text-center" style="font-size: 32px">企业级AI规划与开发服务</h2>
				<div class="product" data-aos="fade-up" data-aos-delay="100">
					<div class="txt" >
						<div class="swiper-container">
							<div class="swiper-wrapper">
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">AI方案咨询服务</div>
										<div class="t2">企业AI战略咨询及应用落地咨询，通过深入了解企业业务，挖掘和明确业务需求点，帮助客户规划AI战略，寻找探索AI技术应用的落地场景</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">大模型代训练及应用开发服务</div>
										<div class="t2">提供高效、稳定的大模型代训练服务及AI应用设计与开发服务</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">AI架构服务</div>
										<div class="t2">帮助客户设计优化算力基础架构，对性能、稳定性、成本等进行调优，负责构建人工智能软件的高效稳定架构体系及AI应用设计软件整体架构</div>
									</div>
								</div>
								<div class="swiper-slide">
									<div class="eee">
										<div class="t1">数据治理</div>
										<div class="t2">对企业结构化/非结构化数据开展系统地治理、挖掘、分析</div>
									</div>
								</div>
							</div>
							<div class="swiper-pagination"></div>
						</div>
					</div>
					<div class="pic">
						<img src="@/assets/images/bwt/ai1.jpg" style="border-radius: 12px;">
					</div>
				</div>
			</div>
		</div>


	</Layout>
</template>

<script>
import Layout from '@/components/common/Layout'
import Separator from '@/components/elements/separator/Separator'
import Swiper from "swiper";
import "swiper/css/swiper.css";
export default {
	name: 'Solution1',
	components: {Separator, Layout},
	data() {
		return {

		}
	},
	mounted() {
		new Swiper(".swiper-container", {
			autoplay: true,
			delay: 2000,
			pagination: {
				el: ".swiper-pagination",
				clickable: true,
				renderBullet: function (index, className) {
					return '<span class="' + className + '">' + (index + 1) + "</span>";
				},
			},
		});
	}
}
</script>
<style lang="scss" scoped>
.sbg {
	background-image: url("../../../assets/images/bwt/sbg.jpg");
}
.product {
	margin-top: 72px;
	display: flex;
	.pic {
		width: 40%;
		img {
			width: 100%;
		}
	}
	.txt {
		width: 60%;
		.eee {
			width: 90%;
			text-align: left;
			.t1 {
				font-size: 24px;
				font-weight: 600;
				color: #000;
			}
			.t2 {
				margin-top: 12px;
				color: #000;
			}
		}
	}

}
.swiper-container {
	width: 100%;
	height: 100%;
	.swiper-wrapper {
		width: 100%;
	}
	.swiper-slide {
		width: 100%;
		text-align: center;
		font-size: 18px;
		background: #fff;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	:deep(.swiper-pagination) {
		bottom: 30px;
	}

	:deep(.swiper-pagination-bullet) {
		width: 20px;
		height: 20px;
		text-align: center;
		line-height: 20px;
		font-size: 12px;
		color: #000;
		opacity: 1;
		background: rgba(0, 0, 0, 0.2);
	}

	:deep(.swiper-pagination-bullet-active){
		color: #fff;
		background: #007aff;
	}
}
</style>
